export const PRODUCTION_DELIVERED_DHL = 19
export const PRODUCTION_IN_TRANSIT_DHL = 18

export default {
	PRODUCTION_DELIVERED_DHL,
	PRODUCTION_IN_TRANSIT_DHL,
}
